import { bannerShow, bannerClick } from '../../firebase'
export default {
  data() {
    return {
      exposedIds: [],
    }
  },
  watch: {
    datas: {
      deep: true,
      handler(list = []) {
        const data = list[0] || {}
        if (list.length === 1 && this.exposedIds.indexOf(data.id) < 0) {
          bannerShow(1, data.id)
          this.exposedIds.push(data.id)
        }
      },
    },
  },
  methods: {
    itemChange() {
      if (!process.client) {
        return
      }
      const activeEle =
        document.querySelector('.swiper-slide.swiper-slide-active') || {}
      const index = activeEle?.dataset?.swiperSlideIndex || 0
      // const index = swiper.realIndex || 0
      const list = this.datas[index] || {}
      const id = list.id
      const { exposedIds } = this
      if (!exposedIds.includes(id)) {
        this.exposedIds = exposedIds.concat(id)
        bannerShow(Number(index) + 1, list.id)
      }
    },
    goDetail(item, index) {
      bannerClick(index * 1 + 1, item.id)
      this.$emit('click', item, 'banner')
    },
  },
}
